/**
 * CCM19 ↔ Shopify Customer Privacy bridge
 * Based on official CCM19 Shopify integration docs.
 *
 * Default: deny analytics/marketing until CCM19 consent is granted.
 * After consent: enable signals based on accepted embeddings / full consent.
 *
 * Embedding names must match CCM19 admin (see docs/ccm19-admin-import-checklist.md).
 */
(function () {
  var intervals = {};
  var shopifyFeaturesLoaded = false;

  // Names as they will appear in CCM19 after import (adjust if renamed in admin).
  var ANALYTICS_EMBEDDINGS = [
    'Microsoft Clarity',
    'Google Analytics',
    'Shopify Pixel'
  ];
  var MARKETING_EMBEDDINGS = [
    'Meta Pixel',
    'Facebook Pixel',
    'Pinterest Tag',
    'Pinterest Tags',
    'Pinterest',
    'Google Ads / Remarketing & Conversion Tracking',
    'Google Ads',
    'Klaviyo',
    'Shopify Pixel',
    'Uppromote'
  ];

  function embeddingAccepted(names) {
    if (typeof CCM === 'undefined' || !CCM.acceptedEmbeddings || !CCM.acceptedEmbeddings.length) {
      return false;
    }
    return CCM.acceptedEmbeddings.some(function (item) {
      var n = (item && item.name) || '';
      return names.some(function (want) {
        return n === want || n.indexOf(want) !== -1;
      });
    });
  }

  function computeSignals() {
    var full = typeof CCM !== 'undefined' && CCM.fullConsentGiven === true;
    var analytics =
      full ||
      embeddingAccepted(ANALYTICS_EMBEDDINGS) ||
      embeddingAccepted(MARKETING_EMBEDDINGS);
    var marketing = full || embeddingAccepted(MARKETING_EMBEDDINGS);

    // Explicit decline / no consent yet
    if (typeof CCM !== 'undefined' && CCM.consent === false && !full) {
      if (!CCM.acceptedEmbeddings || CCM.acceptedEmbeddings.length === 0) {
        analytics = false;
        marketing = false;
      }
    }

    return {
      analytics: !!analytics,
      marketing: !!marketing,
      preferences: false,
      sale_of_data: !!marketing
    };
  }

  function updateShopifyCustomerPrivacy() {
    if (
      typeof window.Shopify === 'object' &&
      typeof window.Shopify.loadFeatures === 'function' &&
      !shopifyFeaturesLoaded
    ) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            console.warn('[CCM19→Shopify] consent-tracking-api load error', error);
          }
        }
      );
      shopifyFeaturesLoaded = true;
    }

    if (
      typeof window.Shopify === 'object' &&
      typeof window.Shopify.customerPrivacy === 'object' &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
    ) {
      var signals = computeSignals();
      window.Shopify.customerPrivacy.setTrackingConsent(signals, function () {
        // no-op; consent synced
      });

      if (intervals.shopifyCustomerPrivacy) {
        window.clearInterval(intervals.shopifyCustomerPrivacy);
        intervals.shopifyCustomerPrivacy = null;
      }
    }
  }

  function updateThirdPartyConsentState() {
    if (!intervals.shopifyCustomerPrivacy) {
      intervals.shopifyCustomerPrivacy = window.setInterval(updateShopifyCustomerPrivacy, 200);
    }
    // Also try immediately
    updateShopifyCustomerPrivacy();
  }

  // Default deny as soon as Customer Privacy API is available (before Accept).
  function defaultDenyUntilConsent() {
    if (
      typeof window.Shopify === 'object' &&
      typeof window.Shopify.customerPrivacy === 'object' &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
    ) {
      if (typeof CCM !== 'undefined' && (CCM.fullConsentGiven || (CCM.acceptedEmbeddings && CCM.acceptedEmbeddings.length))) {
        return;
      }
      window.Shopify.customerPrivacy.setTrackingConsent(
        { analytics: false, marketing: false, preferences: false, sale_of_data: false },
        function () {}
      );
    }
  }

  window.addEventListener('ccm19WidgetClosed', updateThirdPartyConsentState);
  window.addEventListener('CCM19.consentStateChanged', updateThirdPartyConsentState);
  window.addEventListener('ccm19EmbeddingAccepted', updateThirdPartyConsentState);

  // Boot
  updateThirdPartyConsentState();
  var denyIv = window.setInterval(function () {
    defaultDenyUntilConsent();
  }, 200);
  window.setTimeout(function () {
    window.clearInterval(denyIv);
  }, 8000);
})();
